import { Icon, Link, Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import { useTheme } from '@Sage/hoi-poi-ui';
import { useDomainValidation } from '../../hooks/useDomainValidation';

import './styles.scss';
import { useNavigate } from 'react-router-dom';

function DomainVerificationBanner() {
    const { hasValidatedDomain, loading } = useDomainValidation();
    const navigate = useNavigate();
    const bannerText = getLiteral('label_marketing_campaigns_verify_domain_banner');
    const theme = useTheme();

    if (loading || hasValidatedDomain) return null;

    return (
        <div className="domain-verification-banner">
            <div className="domain-verification-banner__content">
                <Icon name="infoOutlined" color={theme.colors.semantic.caution600} />
                <Text type="caption" color={theme.colors.semantic.caution600}>
                    {bannerText}
                </Text>
                <Link
                    onClick={() => navigate('/campaigns/marketing/settings/domains')}
                    type="captionMedium"
                    variation="caution"
                    bold
                    underline
                >
                    {getLiteral('label_click_here')}
                </Link>
            </div>
        </div>
    );
}

DomainVerificationBanner.displayName = 'DomainVerificationBanner';

export default DomainVerificationBanner;
